import { useEffect, useState } from 'react';
import { IAuthState } from './../../contexts';
import { UserService } from './../../services';

/**
 * Factory function that build a useCanReviewProduct hook
 * This hook is use in the product cards to display the form to add a comment
 * @param useAuthentication the hook that handles the authentication
 * @param userService the hook that gets the user informations
 * @returns a hook that is used in product cards, to allow the user to comment the product
 */
export const createUseCanReviewProduct = (
  useAuthentication: () => Partial<IAuthState>,
  userService: UserService,
) => {
  /**
   * This hook is meant to see if the user as already bought the product
   * @param productSKU The product sku  to be tested
   * @returns boolean
   *
   */
  return (productSKU: string): boolean => {
    const { authUser } = useAuthentication();
    const [canReviewProduct, setCanReviewProduct] = useState(false);
    const handleAuthUserChanged = async () => {
      if (authUser) {
        const products = await userService.getUserFrequentlyBoughtProducts(
          authUser.uid,
        );

        setCanReviewProduct(
          products.some((product) => product.sku === productSKU),
        );
      }
    };

    useEffect(() => {
      handleAuthUserChanged();
    }, [authUser]);

    return canReviewProduct;
  };
};
